import apiHeader from '@/helpers/apiHeader';

const sapSyncTaskService = {
	list(page, params) {
    	return apiHeader.get('sap/sap-sync-task?page=' + page, {params});
	},
	create(params) {
    	return apiHeader.post('sap/sap-sync-task', params);
	},
	synchron(sap_sync, key, params) {
    	return apiHeader.post('sap/sap-sync-task/synchron/' + sap_sync + '/' + key, {params});
	},
	resynchron(key, credentials = {}) {
    	return apiHeader.post('sap/sap-sync-task/resynchron', { key, ...credentials });
	},
	getSyncLog(id) {
		return apiHeader.get('sap/sap-sync-task/log-detail/' + id);
	},
	getTasksByMcrCode(mcrCode) {
		return apiHeader.get('sap/sap-sync-task/tasks/' + encodeURIComponent(mcrCode));
	}
};

export default sapSyncTaskService;
